// @ts-nocheck
// contact information modal
import React from "react";
import {
  Button,
  CircularProgress,
  Grid,
  InputLabel,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";

// styles
import styles from "../../create-event/components/contact-information/contactInformation.module.css";

// utils
import PropTypes from "prop-types";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";

// custom components
import { CustomInput } from "../../../components/Custom/Input";
import { updateContactInformationAction } from "../../../store/actions/eventRequest";
import { alertDialogAciton } from "../../../store/actions/auth";
import { addEditLogAction } from "../../../store/actions/logs";
import {
  phoneNumberForApi,
  phoneNumberFormat,
} from "../../../utils/methods/formatters";

export default function ContactInformationTab({
  contactData,
  handleClose,
  updateEvent,
  eventId,
  eventName,
}) {
  const [oldData, setOldData] = React.useState({});
  const { ucLoading } = useSelector((state) => state.eventRequest);
  const { userId } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  let initialValues = {
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    company: "",
  };

  React.useEffect(() => {
    if (contactData) {
      const initialValues = {
        firstName: contactData.firstName,
        lastName: contactData.lastName,
        phone: phoneNumberFormat(contactData.mobile),
        email: contactData.email,
        company: contactData.company,
      };
      setValues(initialValues);
      setOldData(initialValues);
    }
  }, [contactData]);

  const validationSchema = Yup.object().shape({
    firstName: Yup.string()
      .trim()
      .max(100, "First Name should have at most 100 characters!")
      .required("First name required"),
    // .when("company", {
    //   is: (company) => !company || company.trim() === "",
    //   then: () => Yup.string().required("First name required"),
    //   otherwise: () => Yup.string().nullable(),
    // })
    lastName: Yup.string()
      .trim()
      .max(100, "Last Name should have at most 100 characters!")
      .required("Last name required"),
    // .when("company", {
    //   is: (company) => !company || company.trim() === "",
    //   then: () => Yup.string().required("Last name required"),
    //   otherwise: () => Yup.string().nullable(),
    // })
    phone: Yup.string()
      // .length(10, "Phone number must be exactly 10 characters")
      // .matches(/^[0-9]+$/, 'Phone number must contain only numbers')
      .matches(/^\d{3}-\d{3}-\d{4}$/, "Phone number must be of 10 digit")
      .required("Phone number required"),
    email: Yup.string().trim().email("Invalid email").required("Email required"),
    company: Yup.string()
      .trim()
      .max(255, "Company Name should have at most 255 characters!")
      .nullable(),
    // .test(
    //   "company-required",
    //   "Company required if first name and last name are not provided",
    //   function (value) {
    //     const { firstName, lastName } = this.parent;
    //     if (
    //       (!firstName || firstName.trim() === "") &&
    //       (!lastName || lastName.trim() === "")
    //     ) {
    //       return !!value && value.trim() !== "";
    //     }
    //     return true;
    //   },
    // )
  });

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values) => {
      // TODO: API call to update the event
      dispatch(
        updateContactInformationAction({
          payload: {
            data: { ...values, mobile: phoneNumberForApi(values.phone), email: values.email?.trim()?.toLowerCase() },
            contactId: contactData?._id,
          },
          successCallback: () => {
            // window.location.reload();
            // dispatch(
            //   alertDialogAciton({
            //     open: true,
            //     title: "Sucess",
            //     message: "Contact Information updated successfully",
            //   }),
            // );
            // go through all the element of oldData and compare with values
            let previousValues = {};
            let updatedValues = {};
            const normalizedValues = {
              ...values,
              phone: phoneNumberForApi(values.phone),
              email: values.email?.trim()?.toLowerCase(),
            }
            for (const key in oldData) {
              if (oldData[key] !== normalizedValues[key]) {
                previousValues[key] = oldData[key];
                updatedValues[key] = normalizedValues[key];
              }
            }
            dispatch(
              addEditLogAction({
                id: eventId,
                payload: {
                  actionById: userId,
                  eventId: eventId,
                  description: `Contact Information updated of event ${eventName}`,
                  previousValues: previousValues,
                  updatedValues: updatedValues,
                },
              }),
            );
            updateEvent();
            handleClose();
            dispatch(
              alertDialogAciton({
                open: true,
                title: "Success",
                message: "Contact Information updated successfully",
              }),
            );
          },
          failureCallback: ({ message }) => {
            dispatch(
              alertDialogAciton({
                open: true,
                title: "Error",
                message: message || "Something went wrong. Please try again.",
              }),
            );
          },
        }),
      );
    },
  });

  const {
    values,
    setValues,
    handleChange,
    handleBlur,
    touched,
    errors,
    submitForm,
    handleSubmit,
  } = formik;

  const handleMobileChange = (event) => {
    const input = event.target.value;
    const formattedInput = input
      .replace(/\D/g, "")
      .replace(/(\d{1,3})(\d{1,3})?(\d{1,4})?/, function (_, p1, p2, p3) {
        let formattedNumber = "";
        if (p1) {
          formattedNumber += p1;
        }
        if (p2) {
          formattedNumber += "-" + p2;
        }
        if (p3) {
          formattedNumber += "-" + p3;
        }
        return formattedNumber;
      });
    handleChange({
      target: {
        name: "phone",
        value: formattedInput,
      },
    });
  };

  return (
    <Box
      className={styles["dataBox"]}
      sx={{
        border: "none",
        "@media (max-width: 600px)": {
          padding: "15px",
        },
      }}
    >
      {/* <Typography className={styles["createEventTitle"]}> */}
      {/*   Contact Information */}
      {/* </Typography> */}
      <Box className={styles["formDataBox"]}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Box className={styles["form-box"]}>
              <InputLabel>First Name</InputLabel>
              <CustomInput
                fullWidth
                placeholder="Type here..."
                name="firstName"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.firstName}
              />
              {touched.firstName && errors.firstName && (
                <span className={styles.error}>{errors.firstName}</span>
              )}
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box className={styles["form-box"]}>
              <InputLabel>Last Name</InputLabel>
              <CustomInput
                fullWidth
                placeholder="Type here..."
                name="lastName"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.lastName}
              />
              {touched.lastName && errors.lastName && (
                <span className={styles.error}>{errors.lastName}</span>
              )}
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box className={styles["form-box"]}>
              <InputLabel>Phone Number</InputLabel>
              <CustomInput
                fullWidth
                placeholder="XXX-XXX-XXX"
                name="phone"
                onChange={handleMobileChange}
                onBlur={handleBlur}
                value={values.phone}
              />
              {touched.phone && errors.phone && (
                <span className={styles.error}>{errors.phone}</span>
              )}
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box className={styles["form-box"]}>
              <InputLabel>Email</InputLabel>
              <CustomInput
                fullWidth
                placeholder="abc@xyz.com"
                name="email"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.email}
              />
              {touched.email && errors.email && (
                <span className={styles.error}>{errors.email}</span>
              )}
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box className={styles["form-box"]}>
              <InputLabel>Company Name</InputLabel>
              <CustomInput
                fullWidth
                placeholder="Type here..."
                name="company"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.company}
              />
              {touched.company && errors.company && (
                <span className={styles.error}>{errors.company}</span>
              )}
            </Box>
          </Grid>
        </Grid>

        <Box className="bottom-btn-box">
          <Button
            className="btn-black"
            onClick={() => {
              formik.setValues(initialValues);
              handleClose();
            }}
          >
            <Typography className="btn-text">CLOSE</Typography>
          </Button>
          <Button
            sx={{
              cursor: ucLoading ? "not-allowed" : "pointer",
            }}
            disableRipple={ucLoading}
            className="btn-pink"
            onClick={() => {
              if (ucLoading) return;
              handleSubmit();
            }}
          >
            {ucLoading ? (
              <CircularProgress />
            ) : (
              <Typography className="btn-text">Submit</Typography>
            )}
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

ContactInformationTab.propTypes = {
  contactData: PropTypes.object,
  handleClose: PropTypes.func.isRequired,
  updateEvent: PropTypes.func.isRequired,
  eventId: PropTypes.string,
  eventName: PropTypes.string,
};